export function isFutureDate(date) {
  var now = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Date();
  return now < date;
}